var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonOnePlatFormActions from "@redux/actions/common/commonActions";
export var UPDATE_PENDING_TRANSACTIONS = "UPDATE_PENDING_TRANSACTIONS";
export var UPDATE_PENDING_TRANSACTION_BY_ID = "UPDATE_PENDING_TRANSACTION_BY_ID";
export var UPDATE_ASSIGN_TO_SELF = "UPDATE_ASSIGN_TO_SELF";
export var UPDATE_APPROVE_REJECT_STATUS = "UPDATE_APPROVE_REJECT_STATUS";
export var UPDATE_DOCUMENT_LIST = "UPDATE_DOCUMENT_LIST";
export var UPDATE_DOCUMENT_DETAILS = "UPDATE_DOCUMENT_DETAILS";
export var UPDATE_MODIFY_TRANSACTION = "UPDATE_MODIFY_TRANSACTION";
export var UPDATE_FOLIO_DETAILS = "UPDATE_FOLIO_DETAILS";
export var UPDATE_PENDING_COUNT = "UPDATE_PENDING_COUNT";
export var UPDATE_DOWNLOAD_PENDING_TRANSACTION = "UPDATE_DOWNLOAD_PENDING_TRANSACTION";
export var UPDATE_UPLOAD_DOCS = "UPDATE_UPLOAD_DOCS";
export var UPDATE_DELETE_DOCS = "UPDATE_DELETE_DOCS";
var QualityCheckActions = /** @class */ (function (_super) {
    __extends(QualityCheckActions, _super);
    function QualityCheckActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //
    QualityCheckActions.prototype.pendingTransactions = function (response) {
        this.dispatch({
            type: UPDATE_PENDING_TRANSACTIONS,
            payload: {
                pendingTransactions: response,
            },
        });
    };
    QualityCheckActions.prototype.pendingTransactionById = function (response) {
        this.dispatch({
            type: UPDATE_PENDING_TRANSACTION_BY_ID,
            payload: {
                pendingTransactionById: response,
            },
        });
    };
    QualityCheckActions.prototype.assignToSelf = function (response) {
        this.dispatch({
            type: UPDATE_ASSIGN_TO_SELF,
            payload: {
                assignToSelf: response,
            },
        });
    };
    QualityCheckActions.prototype.updateApproveRejectStatus = function (response) {
        this.dispatch({
            type: UPDATE_APPROVE_REJECT_STATUS,
            payload: {
                updateApproveRejectStatus: response,
            },
        });
    };
    QualityCheckActions.prototype.documentList = function (response) {
        this.dispatch({
            type: UPDATE_DOCUMENT_LIST,
            payload: {
                documentList: response,
            },
        });
    };
    QualityCheckActions.prototype.documentDetails = function (response) {
        this.dispatch({
            type: UPDATE_DOCUMENT_DETAILS,
            payload: {
                documentDetails: response,
            },
        });
    };
    QualityCheckActions.prototype.modifyTransaction = function (response) {
        this.dispatch({
            type: UPDATE_MODIFY_TRANSACTION,
            payload: {
                modifyTransaction: response,
            },
        });
    };
    QualityCheckActions.prototype.folioDetails = function (response) {
        this.dispatch({
            type: UPDATE_FOLIO_DETAILS,
            payload: {
                folioDetails: response,
            },
        });
    };
    QualityCheckActions.prototype.pendingCount = function (response) {
        this.dispatch({
            type: UPDATE_PENDING_COUNT,
            payload: {
                pendingCount: response,
            },
        });
    };
    QualityCheckActions.prototype.downloadPendingTransaction = function (response) {
        this.dispatch({
            type: UPDATE_DOWNLOAD_PENDING_TRANSACTION,
            payload: {
                downloadPendingTransaction: response,
            },
        });
    };
    QualityCheckActions.prototype.uploadDocs = function (response) {
        this.dispatch({
            type: UPDATE_UPLOAD_DOCS,
            payload: {
                uploadDocs: response,
            },
        });
    };
    QualityCheckActions.prototype.deleteDocs = function (response) {
        this.dispatch({
            type: UPDATE_DELETE_DOCS,
            payload: {
                deleteDocs: response,
            },
        });
    };
    return QualityCheckActions;
}(CommonOnePlatFormActions));
export default QualityCheckActions;
